import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_API_URL } from '../../api/config';
import ENDPOINTS from '../../api/endPoints';
import {
  fetchReviewAnalysisRequest,
  fetchReviewAnalysisSuccess,
  fetchReviewAnalysisFailure,
} from '../slices/reviewAnalysisSlice';
import type { ReviewAnalysisResponse, ReviewAnalysisData } from '../../components/reviewAnalysis/types';

function* fetchReviewAnalysisSaga(action: PayloadAction<string>): Generator<any, void, any> {
  try {
    const restaurantId = action.payload;
    const url = `${ENDPOINTS.generated_content}/${restaurantId}?content_type=REVIEW_ANALYSIS`;
    const response = yield call(axios.get, url);

    const apiResponse: ReviewAnalysisResponse = response.data;
    
    if (apiResponse.data && apiResponse.data.length > 0) {
      const contentPayload = JSON.parse(apiResponse.data[0].content_payload);
      const analysisData: ReviewAnalysisData = contentPayload[0];
      yield put(fetchReviewAnalysisSuccess(analysisData));
    } else {
      yield put(fetchReviewAnalysisFailure('No review analysis data found'));
    }
  } catch (error: any) {
    yield put(
      fetchReviewAnalysisFailure(
        error.response?.data?.message || error.message || 'Failed to fetch review analysis'
      )
    );
  }
}

export function* reviewAnalysisSaga() {
  yield takeLatest(fetchReviewAnalysisRequest.type, fetchReviewAnalysisSaga);
}
